module.exports = __webpack_public_path__ + "static/Raghav_Resume-7d3ab84672671a9ee4ee7f94d23b631e.pdf";